export const rootTranslate = 'resources.bookings';
